<template>
  <div>
    <div class="dialogue-check el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">{{ prefix || 'Was' }}</div>

      <div v-if="errors.length" class="el-input-group__prepend">
        <help-tooltip type="error">
          <span v-for="error in errors" :key="error.message">{{ error.message }}</span>
        </help-tooltip>
      </div>

      <el-tooltip
        :disabled="!selectedContent"
        :visible-arrow="false"
        :content="selectedContent"
        placement="top"
      >
        <el-select
          v-close-on-zoom
          :value="state.selectedItem"
          :placeholder="placeholder"
          class="item-select"
          :disabled="readonly"
          @input="questionId => selectItem(questionId)"
        >
          <el-option
            v-for="item in getDialogueItems(emitter.caseConf)"
            :key="item.id"
            :label="getDialogueItemContent(item).en"
            :value="item.id"
          />
        </el-select>
      </el-tooltip>

      <div v-if="verb" class="el-input-group__append">{{ verb }}</div>
      <el-select
        id="operator-select"
        v-close-on-zoom
        :value="state.operator"
        placeholder="exactly"
        class="operator-select"
        :disabled="readonly"
        @input="operator => updateOperator(operator)"
      >
        <el-option v-for="op in operators" :key="op.value" :label="op.label" :value="op.value" />
      </el-select>
      <el-input
        v-integer-only
        type="number"
        placeholder="any amount of"
        :disabled="readonly"
        :value="state.count"
        :min="0"
        class="count-input"
        @change="value => updateCount(parseInt(value))"
      >
        <template slot="append">times</template>
      </el-input>
    </div>
  </div>
</template>

<script>
import { get, isNumber, uniqBy } from 'lodash';
import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'dialogue-check',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'checkType',
    'placeholder',
    'prefix',
    'verb',
    'getDialogueItems',
    'getDialogueItemContent'
  ],
  data() {
    return {
      state: {
        selectedItem: null,
        count: null,
        operator: 'EQUAL',
        displayIndex: null,
      },
      operators: [
        { value: 'LESS_THAN', label: 'less than' },
        { value: 'EQUAL', label: 'exactly' },
        { value: 'GREATER_THAN', label: 'more than' },
      ],
    };
  },
  computed: {
    selectedContent() {
      const items = this.getDialogueItems(this.emitter.caseConf) || [];
      const item = items.find(i => i.id === this.state.selectedItem);
      const content = item ? this.getDialogueItemContent(item) : null;
      return content ? content.en : '';
    },
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(error => error.metadata && error.metadata.checkKey === this.ikey);

      return uniqBy(errors, 'message');
    },
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.update();
  },
  methods: {
    syncState() {
      const data = this.getData(this.ikey);
      this.state.selectedItem = get(data, 'id');
      this.state.count = get(data, 'count');
      this.state.operator = get(data, 'operator') || 'EQUAL';
      this.state.displayIndex = this.control.displayIndex;
    },
    selectItem(itemId) {
      this.state.selectedItem = itemId;
      this.update();
    },
    updateCount(count) {
      if (isNumber(count)) {
        this.state.count = count;
      } else {
        this.state.count = null;
      }
      this.update();
    },
    updateOperator(operator) {
      this.state.operator = operator;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: this.checkType,
        id: this.state.selectedItem,
        operator: this.state.operator,
        value: true,
        count: this.state.count,
        displayIndex: this.state.displayIndex,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.operator-select {
  width: 110px;
}
.count-input {
  width: 190px;
}
</style>
